export default __webpack_public_path__ + "static/media/straw.645b055e.png";